/**
 * Settings meters (design-language §3 "Meters"): neutral `text-3` fill that turns amber only when
 * something waits (or a quota crosses `warnAt`). Red never means "full". `Gauge` is the labelled
 * row: label, value on the right, the bar, an optional sub line.
 */
import type { ReactNode } from 'react'
import './settings-ui.css'

export function QuietMeter({ pct, label, wait }: { pct: number; label: string; wait?: boolean }) {
  const p = Math.max(0, Math.min(100, pct))
  return (
    <div
      className={`st-meter${wait ? ' is-wait' : ''}`}
      role="meter"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(p)}
      aria-label={label}
    >
      <i style={{ transform: `scaleX(${p / 100})` }} />
    </div>
  )
}

export function Gauge({
  label,
  value,
  pct,
  meterLabel,
  wait,
  sub,
}: {
  label: ReactNode
  value: ReactNode
  pct: number
  meterLabel: string
  wait?: boolean
  sub?: ReactNode
}) {
  return (
    <div className="st-gauge">
      <div className="st-gauge__line">
        <span className="min-w-0">{label}</span>
        <span className={`st-gauge__value${wait ? ' is-wait' : ''}`}>{value}</span>
      </div>
      <QuietMeter pct={pct} label={meterLabel} {...(wait ? { wait } : {})} />
      {sub ? <div className="st-gauge__sub">{sub}</div> : null}
    </div>
  )
}
